import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import ProductCard from '../../../components/common/ProductCard';
import { setSelectedComplementaryAOVSKU } from '../../../slices/pdp';
import styles from './ComplementaryAOV.module.scss';
import useDrupalSettings from '../../../hooks/useDrupalSettings';
import VariantSelection from '../VariantSelection';

const ComplementaryAOV = () => {
  const dispatch = useDispatch();
  const { aovs } = useDrupalSettings();
  const { locale } = useIntl();

  const { selectedSKU, selectedComplementaryAOVSKU } = useSelector(
    (state) => state.pdp
  );

  const complementaryAOVForSelectedSKU = aovs?.find(
    (aov) => aov.targetSku === selectedSKU
  )?.complementary;

  return complementaryAOVForSelectedSKU ? (
    <>
      <div className={styles['complementary-aov-title']}>
        {complementaryAOVForSelectedSKU?.title[locale]}
      </div>
      <div className={styles['complementary-options-container']}>
        {complementaryAOVForSelectedSKU?.options?.map(
          (complementaryAOVOption) => {
            const variantSelected = complementaryAOVOption.variants?.find(
              (variant) => variant.sku === selectedComplementaryAOVSKU
            );
            const isProductVariantSelected = !!variantSelected;
            const currentVariantForComplementaryAOVOption =
              variantSelected ??
              complementaryAOVOption.variants?.find(
                (variant) => variant.masterVariant === true
              ) ??
              complementaryAOVOption.variants?.[0];

            if (currentVariantForComplementaryAOVOption) {
              return (
                <>
                  <ProductCard
                    key={`ComplementaryAOV_${complementaryAOVOption.productId}`}
                    title={complementaryAOVOption.productName[locale]}
                    id={currentVariantForComplementaryAOVOption.sku}
                    name={currentVariantForComplementaryAOVOption.sku}
                    description={complementaryAOVOption.description[locale]}
                    price={currentVariantForComplementaryAOVOption.price}
                    discount={currentVariantForComplementaryAOVOption.discount}
                    imageURL={currentVariantForComplementaryAOVOption.image}
                    isSelected={isProductVariantSelected}
                    onChange={(sku) => {
                      dispatch(
                        setSelectedComplementaryAOVSKU({
                          selectedComplementaryAOVSKU:
                            selectedComplementaryAOVSKU !== sku
                              ? sku
                              : undefined,
                        })
                      );
                    }}
                    badge={complementaryAOVOption.badgeLabel}
                  />
                  {isProductVariantSelected &&
                    complementaryAOVOption.variants.length > 1 && (
                      <div className={styles['variant-selector-container']}>
                        <VariantSelection
                          variants={complementaryAOVOption.variants}
                          defaultSelectedSKU={
                            currentVariantForComplementaryAOVOption?.sku
                          }
                          onSelectVariant={({ sku }) => {
                            dispatch(
                              setSelectedComplementaryAOVSKU({
                                selectedComplementaryAOVSKU: sku,
                              })
                            );
                          }}
                        />
                      </div>
                    )}
                </>
              );
            }
            return null;
          }
        )}
      </div>
    </>
  ) : null;
};

export default ComplementaryAOV;
